<template>
	<div>
		<div class="deposit-modal-spacing has-text-left">
			<div v-if="process_status === 'processing' && funds.type === 'withdraw'" class="header-bar-global">
				{{ $t('withdraw_page.SEND_TOKENS') }}
			</div>
			<div v-else-if="process_status === 'processing'" class="header-bar-global">
				{{ $t('funds.DEPOSIT_PROCESSING') }}
			</div>
			<div v-else-if="process_status === 'success'" class="header-bar-global">
				{{ $t('funds.DEPOSIT_SUCCESS') }}
			</div>

			<div v-else-if="process_status === 'withdraw_complete'" class="header-bar-global">
				{{ $t('withdraw_page.WITHDRAW_COMPLETE') }}
			</div>

			<div v-else-if="process_status === 'error'" class="header-bar-global">
				{{ $t('funds.DEPOSIT_ERROR') }}
			</div>

			<div v-else-if="process_status === 'send'" class="header-bar-global">
				{{ $t('withdraw_page.SEND_TOKENS') }}
			</div>

			<div v-else class="header-bar-global">
				<button class="button back-btn" @click="toggleDepositWithdrawModal(false);">
					<img src="@/assets/funds/arrow-left.svg" alt="Back" />
				</button>
				{{ $t('funds.COINBASE_PROCESSING') }}
			</div>

			<!-- send eth to finish withdrawal -->
			<div v-if="process_status === 'processing' && funds.type === 'withdraw'" class="payment-flow_box">
				<div class="has-text-centered pending-img">
					<img v-if="showLoader" class="loader-icon is-64" src="@/assets/icons/loader.svg" />
					<img v-else src="@/assets/funds/send.svg" alt="Send Ethereum" />
				</div>

				<p class="has-text-centered" >
					{{ $t('funds.SEND_ETH') }}
				</p>

				<div class="transaction_details_section mt-15">
					<div class="transaction_header gap-8 " v-if="eth_send">
						<img  :src="imageURL('@/img/funds/tokens/eth.svg')"
							class="transaction_icon" />
						<div>
							<p> {{ roundFormatter(eth_send.sell_amount) }} ETH</p>
						</div>
					</div>
					<div class="transaction_header gap-8 no-border" v-if="eth_send">
						<img :src="imageURL('@/img/funds/tokens/destination.svg')"
							class="transaction_icon" />
						<div>
							<p >{{ $t('funds.DESTINATION') }}</p>
							<p class="is-size-12 has-text-weight-normal provider-detail">
								<span>
									{{ $t('funds.WALLET_TYPE_COINBASE') }} -
								</span>{{ formatEthAddressLong(eth_send.to_address) }}
							</p>
						</div>
					</div>
				</div>

				<button  :class="{'is-loading':sendExecuting}" :disabled="eth_send == null || sendExecuting || tx_hash !== null" class="button plain-blue-btn is-full-width xlarge mt-15  " @click="executeSend">
					<span v-if="tx_hash">{{ $t('funds.TRANSACTION_SENT') }}</span>
					<span v-else>{{ $t('funds.SEND_ETH_BUTTON') }}</span>
				</button>
				<!-- <p v-if="tx_hash" class="is-size-7 has-text-centered mt-10">
					{{ $t('funds.TRANSACTION_HASH') }}: {{ formatEthAddressLong(tx_hash) }}
				</p> -->

			</div>

			<!-- payment requested - process payment in coinbase window -->
			<div v-else-if="process_status === 'requested'" class="payment-flow_box">
				<div class="has-text-centered pending-img">
					<img v-if="showLoader" class="loader-icon is-64" src="@/assets/icons/loader.svg" />
					<img v-else src="@/assets/funds/continue.svg" alt="external window" />
				</div>

				<div class="payment_provider_section">
					<img src="@/assets/funds/coinbase.svg" class="transaction_icon" alt="payment provider" />

					<div class="provider_text">
						<div class="provider_header">
							{{ $t('funds.COINBASE') }}
						</div>
						<p class="is-size-14 has-text-weight-medium">
							{{ $t('funds.CONTINUE_POPUP_WINDOW') }} <br />
							{{ $t('funds.MOONPAY_NOT_WORKING') }}
							<a class="transition-faster" @click="openCoinbaseWindow()">{{ $t('funds.MOONPAY_LAUNCH')
								}}</a>
						</p>
						<p class="is-size-7">
							{{ $t('funds.TRANSACTION_DETAILS') }} <a @click="cancelPurchase()">{{ $t('funds.FUNDS')
								}}</a>
						</p>
					</div>
				</div>
				<div id="coinbase-sdk" ref="continue_button">
					<a class="donate-with-crypto" id="coinbase-button-container"
						href="https://commerce.coinbase.com/checkout/6da189f179bc31">
						<span>Open Coinbase</span>
					</a>
				</div>
			</div>

			<!-- payment processing - after coinbase submitted - waiting for deposit -->
			<div v-else-if="process_status === 'processing'" class="payment-flow_box">
				<div class="has-text-centered pending-img">
					<img src="@/assets/funds/processing.svg" alt="pending icon" />
				</div>

				<div class="payment_provider_section">
					<div>
						<img src="@/assets/funds/coinbase.svg" class="transaction_icon" alt="payment provider" />
					</div>

					<div class="provider_text">
						<div class="provider_header">
							{{ $t('funds.COINBASE') }}
						</div>
						<p>{{ $t('funds.TRANSACTION_PROCESSING') }} {{ $t('funds.CLOSE_WINDOW') }}</p>
						<p class="is-size-7">
							{{ $t('funds.TRANSACTION_DETAILS') }} <a @click="cancelPurchase()">{{ $t('funds.FUNDS')
								}}</a>
						</p>
					</div>
				</div>

				<!-- Back to Funds -->
				<button class="button flat-white-btn xlarge is-fullwidth mt-15" @click="cancelPurchase()">
					{{ $t('funds.CLOSE_PAYMENT') }}
				</button>
			</div>

			<!-- successful withdrawal -->
			<div v-else-if="process_status === 'withdraw_complete'">
				<div class="has-text-centered pending-img">
					<img src="@/assets/funds/success.svg" alt="success checkmark" />
				</div>

				<div class="transaction_details_section" v-if="eth_send">
					<div class="transaction_header gap-8" >
						<img 
							:src="imageURL('@/img/funds/tokens/mph.svg')"
							class="provider-icon" />
						<div class="">
							{{ roundFormatter(eth_send.mph_amount) }}
							MPH
						</div>
					</div>

					<div class="transaction_details_lines">
						<div class="transaction_details_line transaction_details_line-border">
							<p class="has-text-weight-medium">
								{{ $t('funds.PRICE') }}
							</p>
							<p>${{ usdFormatter(eth_send.mph_price) }} / MPH</p>
						</div>

						<div class="transaction_details_line transaction_details_line-border">
							<p class="has-text-weight-medium">
								{{ $t('funds.WITHDRAW_AMOUNT') }}
							</p>
							<p>
								${{
									usdFormatter(
										eth_send.mph_amount *
										eth_send.mph_price
									)
								}}
							</p>
						</div>
						<div class="transaction_details_line transaction_details_line-border">
							<p class="has-text-weight-medium">
								{{ $t('funds.WITHDRAWAL_FEE') }}
								<b-tooltip :label="$t('funds.WITHDRAWAL_FEE_DESC')" size="is-small" position="is-right"
									type="is-dark" class="ToolTipText" multilined animated>
									<a class="dark-hover transition-faster is-size-14">
										<b-icon icon="question-circle" pack="fas" size="is-small" />
									</a>
								</b-tooltip>
							</p>
							<p>
								${{
									usdFormatter(
										100 *
										eth_send.mph_price
									)
								}}
							</p>
						</div>

						<div class="transaction_details_line">
							<p class="has-text-weight-medium">
								{{ $t('funds.TOTAL_VALUE') }}
							</p>
							<div class="has-text-right">
								<p>
									${{
										usdFormatter(
											(eth_send.mph_amount  - 100)  *
											eth_send.mph_price
										)
									}}
								</p>
								<p class="transaction_details_info_extra">
									{{
										roundFormatter(
											eth_send.mph_amount - 100 
										)
									}}
									MPH
								</p>
							</div>
						</div>
					</div>
				</div>

				<div class="deposit_section no_shadow mt-15">
					<div class="wallet-details"
						v-if="eth_send && eth_send.to_address">
						<div class="centered-flex-gap gap-8">
							<img v-if="funds.withdraw_currency.icon" :src="imageURL('@/img/funds/tokens/destination.svg')"
								class="transaction_icon" />
							<div class="is-line-height-20">
								<p class="has-text-weight-medium  is-size-6">
									{{ $t('funds.DESTINATION') }}
								</p>
								<p class="is-size-14 provider-detail">
									<span >
										{{ $t('funds.WALLET_TYPE_COINBASE') }} -
									</span>
									{{ formatEthAddressLong(eth_send.to_address) }}
								</p>
							</div>
						</div>
						<button class="button back-btn ml-1"
							@click="bookmarkAddress(eth_send.to_address)"
							v-if="chainName==='OLD'"
							:title="$t('funds.ADD_WALLET')">
							<img src="@/assets/funds/bookmark.svg" class="bookmark-icon" />
						</button>
					</div>
				</div>

				<!-- Back/Continue Buttons -->
				<div class="has-text-centered mt-20">
					<!-- Back to Funds -->
					<button class="button flat-white-btn large is-fullwidth mt-20" @click="cancelPurchase()">
						{{ $t('funds.CLOSE_PAYMENT') }}
					</button>
				</div>
			</div>

			<!-- payment success - after deposit completed -->
			<div v-else-if="process_status === 'success'" class="payment-flow_box">
				<div class="has-text-centered pending-img">
					<img src="@/assets/funds/success.svg" alt="Success checkmark image" />
				</div>

				<div class="transaction_details_section" v-if="transaction_data && transaction_data.payload">
					<div class="transaction_header">
						<img src="@/assets/funds/coinbase.svg" class="transaction_icon" alt="payment provider" />
						{{ roundFormatter(transaction_data.payload.payment_crypto_amount) }}
						{{ transaction_data.payload.payment_crypto_currency }}
					</div>

					<div class="transaction_details_lines">
						<div class="transaction_details_line">
							<p class="has-text-weight-medium">
								{{ $t('funds.MPH_CONVERSION') }}
							</p>
							<p>{{ roundFormatter(transaction_data.payload.purchase_amount_mph) }} MPH</p>
						</div>
						<div class="transaction_details_line">
							<p class="has-text-weight-medium">
								{{ $t('funds.COINBASE_FEES') }}
							</p>
							<p>${{ formatAmount(transaction_data.payload.purchase_fees_usd) }}</p>
						</div>
						<div class="transaction_details_line">
							<p class="has-text-weight-medium">
								{{ $t('funds.TOTAL_VALUE') }}
							</p>
							<p>${{ formatAmount(transaction_data.payload.purchase_total_usd) }}</p>
						</div>
					</div>
				</div>

				<!-- Back to Funds -->
				<button class="button flat-white-btn xlarge is-fullwidth mt-15" @click="cancelPurchase()">
					{{ $t('funds.CLOSE_PAYMENT') }}
				</button>
			</div>

			<!-- payment error -->
			<div v-else-if="process_status === 'error'" class="payment-flow_box">
				<div class="has-text-centered pending-img">
					<img src="@/assets/funds/error.svg" alt="payment error" />
				</div>

				<div class="payment_provider_section">
					<div class="provider_text">
						<p class="is-size-14">
							{{ $t('funds.ERROR_TEXT') }}
							{{ $t('funds.ERROR_TRY_AGAIN') }}
						</p>
						<p class="is-size-7">
							{{ $t('funds.LEARN_MORE_DEPOSITS') }}
							<a target="_blank" :href="supportArticleLink('DepositMethod')">{{
								$t('funds.HERE')
							}}</a>.
						</p>
					</div>
				</div>

				<!-- Back to Funds -->
				<button class="button flat-white-btn xlarge is-fullwidth mt-15"
					@click="toggleDepositWithdrawModal(false);">
					{{ $t('BACK') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { parseEther } from 'viem';
import PaymentMixin from '@/mixins/payment.mixin';
import { TransactionService } from '@/services/TransactionService';
import { UserService } from '@/services/UserService';
import type { FundsState } from '@/helpers/types';
/* @group Application_View */
/*
  <h4> <b> Fund Account Pages </b> </h4>
  <br>
  <br> Dedicated routes for deposit and withdrawal flows.
  <br> Works in conjunction with PortfolioFunds page.
*/
export default defineComponent({
	name: 'PaymentTypeCoinbase',
	mixins: [PaymentMixin],
	components: {},
	props: {
		currencySymbol: {
			type: String,
			required: true
		},
		maxLeft: {
			type: Number,
			required: true
		},
		currencyExchange: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			showLoader: true,
			retry_count: 0,
			eth_send: null as any,
			sendExecuting: false,
			tx_hash: null as string | null, // To store the transaction hash
		};
	},
	async mounted() {


		this.process_status = 'requested';
		this.purchase_price = String(this.balance.mph_rate);
		this.purchase_cost = String(this.funds.amount);
		this.purchase_fees = '0';
		this.purchase_total = String(this.funds.amount);
		this.purchase_amount_mph = String(Number(this.funds.amount) / Number(this.balance.mph_rate));
		if (this.funds.step === 'processing') {
			this.process_status = 'processing';
			if (this.funds.type === 'withdraw') {
				this.getWithdrawalTransactions()
			} else {
				this.getSwapTransactions();
			}

		} else {
			this.createPurchase();
		}

	},
	methods: {


		async getWithdrawalTransactions() {
			try {
				const withdrawal = await TransactionService.getCoinbaseWithdrawal({eth_address: this.user?.activePortfolio?.eth_address || ''});
				if (withdrawal.data?.getCoinbaseWithdrawal?.length > 0) {
					let data = withdrawal.data.getCoinbaseWithdrawal[0]
					console.log({data})
					const to_address = data?.payload?.to_address
					const sell_amount = data?.payload?.sell_amount
					const sell_currency = data?.payload?.sell_currency
					const eth_address = data?.eth_address
					const id = data?.id
					const mph_amount = (data?.amount || 0) / 10**18
					const mph_price= (data?.mph_price || 0) / 10**8

					// Basic validation
					if (to_address && sell_amount && sell_currency === 'ETH' && eth_address) {
						this.eth_send = {to_address, sell_amount, sell_currency, eth_address, mph_amount, mph_price, id}
						console.log({to_address, sell_amount, sell_currency, eth_address})
					} else {
						console.error('Invalid withdrawal data received:', data);
						this.process_status = 'error'; // Set error state if data is invalid
						this.$buefy.dialog.alert({
							title: this.$t('ERROR'),
							message: this.$t('funds.INVALID_WITHDRAWAL_DATA'),
							confirmText: this.$t('OK')
						});
					}
				} else {
					console.warn('No pending Coinbase withdrawals found.');
					// Handle case where no withdrawal is found, maybe show a message or different state
					this.process_status = 'error'; // Or another appropriate status
					this.$buefy.dialog.alert({
						title: this.$t('NOTICE'),
						message: this.$t('funds.NO_PENDING_WITHDRAWAL'),
						confirmText: this.$t('OK')
					});
				}
			} catch (error) {
				console.error('Error fetching withdrawal transactions:', error);
				this.process_status = 'error';
				this.$buefy.dialog.alert({
					title: this.$t('ERROR'),
					message: this.$t('funds.ERROR_FETCHING_WITHDRAWAL'),
					confirmText: this.$t('OK')
				});
			} finally {
				this.showLoader = false;
			}
		},

		async getSwapTransactions() {
			let deposits = await TransactionService.getCoinbaseDeposit({eth_address: this.user?.activePortfolio?.eth_address || ''});

			if (deposits.data?.getCoinbaseDeposit?.length > 0) {

				let eth_amount = 0;
				deposits.data?.getCoinbaseDeposit.forEach((item: any) => {
					eth_amount += Number(item?.payload?.purchase_total || 0);
				});


				this.openFunds({
					type: 'deposit',
					provider: 'morpher',
					currency: 'ETH',
					chain: 'base',
					showPaymentMethod: false,
					showOfframpProvider: false,
					step: 'swap',
					showPaymentType: null,
					withdraw_amount: 0,
					amount: eth_amount,
					showWithdrawAddress: false,
					showWithdrawMethod: false,
					withdraw_page: '',
					withdraw_account: '',
					withdraw_account_name: '',
					source: 'finish_swap'
				} as FundsState);
			} else {
				if (this.retry_count < 5) {
					this.retry_count++;
					window.setTimeout(() => {
						this.getSwapTransactions();
					}, 5000);
				} else {
					this.process_status = 'error';
					this.$buefy.dialog.alert({
						title: this.$t('PAYMENT_CREATION_ERROR'),
						message: this.$t('funds.COINBASE_ERROR_MESSAGE'),
						confirmText: this.$t('OK')
					});
				}
			}

			this.showLoader = false;
		},

		async openCoinbaseWindow() {


			let url = this.funds.current_order.payload.hosted_url


			window.open(url, '_blank');

		},
		showCoinbase() {
			const frame = document.getElementsByClassName('bwc-modal-container');
			if (frame && frame.length > 0) {
				//frame[0].style.display = 'block';
				document.getElementById('coinbase-button-container')?.click();
			} else {
				window.setTimeout(() => {
					this.showCoinbase();
				}, 100);
			}
		},

		async executeSend() {

			if (!this.eth_send || !this.eth_send.to_address || !this.eth_send.sell_amount) {
				console.error('Missing withdrawal details.');
				this.$buefy.dialog.alert({
					title: this.$t('ERROR'),
					message: this.$t('funds.MISSING_WITHDRAWAL_DETAILS'),
					confirmText: this.$t('OK')
				});
				return;
			}

			if (!this.walletClient) {
				console.error('Wallet client not available.');
				this.$buefy.dialog.alert({
					title: this.$t('ERROR'),
					message: this.$t('funds.WALLET_CLIENT_NOT_READY'),
					confirmText: this.$t('OK')
				});
				return;
			}

			this.sendExecuting = true;
			this.tx_hash = null; // Reset hash before sending

			try {
				const recipientAddress = this.eth_send.to_address as `0x${string}`;
				const amountInEth = this.eth_send.sell_amount;
				const amountInWei = parseEther(String(amountInEth)); // Convert ETH string/number to wei BigInt

				console.log(`Sending ${amountInEth} ETH (${amountInWei} wei) to ${recipientAddress} via walletClient...`);

				// WalletClient is already connected to the correct account and network
				const hash = await this.walletClient.sendTransaction({
					to: recipientAddress,
					value: amountInWei,
					account: this.user?.eth_address,
				});

				console.log('Transaction sent successfully. Hash:', hash);
				this.tx_hash = hash;

				if (this.user?.eth_address && this.eth_send.id && hash)
					await TransactionService.completeWithdrawalSwapTransaction({eth_address: this.user?.eth_address, id: this.eth_send.id, tx_hash: hash })

				this.process_status = 'withdraw_complete'

				// TODO: Add call to backend service to update the withdrawal record with the tx_hash
				// e.g., await TransactionService.updateWithdrawalTransaction(this.withdrawal_id, { tx_hash: hash });

				// this.$buefy.toast.open({
				// 	message: this.$t('funds.TRANSACTION_SENT_SUCCESS'),
				// 	type: 'is-success',
				// 	position: 'is-bottom'
				// });

			} catch (error: any) {
				console.error('Error sending ETH transaction:', error);
				this.tx_hash = null; // Clear hash on error
				let errorMessage = this.$t('funds.ERROR_SENDING_ETH');

				// Try to get a more specific error message
				if (error.shortMessage) {
					errorMessage += `: ${error.shortMessage}`;
				} else if (error.message) {
					errorMessage += `: ${error.message}`;
				}

				this.$buefy.dialog.alert({
					title: this.$t('ERROR'),
					message: errorMessage,
					confirmText: this.$t('OK')
				});
				// Optionally log the full error details
				this.logSentryError('Coinbase ETH Send Error', error);

			} finally {
				this.sendExecuting = false;
			}
		},
		bookmarkAddress(address: string) {

				this.$router.push('/funds').catch(() => { });
				this.updateFunds({
					showPaymentType: null,
					showWithdrawMethod: false,
					withdraw_page: '',
					withdraw_amount: 0,
					bookmark_address: address
				});
				this.toggleDepositWithdrawModal(false);
			
		},
		async createPurchase() {
			try {
				this.purchase_loading = true;
				// update the backend with the new user balances.
				const result = await TransactionService.purchaseCoinbaseOrderRequest({
					data: {
						eth_address: this.user?.activePortfolio?.eth_address || '',
						order_id: this.order_id,
						transaction_id: this.transaction_id,
						currency: this.funds.currency,
						amount: String(this.funds.amount),
					}
				});
				if (result && result.data?.purchaseCoinbaseOrderRequest) {
					if (
						result.data.purchaseCoinbaseOrderRequest.payload &&
						result.data.purchaseCoinbaseOrderRequest.payload.result === 'error'
					) {
						TransactionService.purchasePaypalOrderCaptureError({
							data: {
								provider: 'coinbase',
								total_amount_usd: '',
								total_amount_mph: '',
								country: this.user?.document_country,
								error_details:
									'Coinbase Purchase Order Request Error - ' + result.data.purchaseCoinbaseOrderRequest.payload.message,
								eth_address: this.user?.activePortfolio?.eth_address
							}
						});
						this.logSentryError(
							'Coinbase Purchase Order Request Error - ' + result.data.purchaseCoinbaseOrderRequest.payload.message
						);
						this.$buefy.dialog.alert({
							title: this.$t('PAYMENT_CREATION_ERROR'),
							message: result.data.purchaseCoinbaseOrderRequest.payload.message || this.$t('PAYMENT_CREATION_ERROR_MESSAGE'),
							confirmText: this.$t('OK')
						});
						this.$router.push('/funds/purchase/coinbase-error').catch(() => { });
						this.purchase_loading = false;

						return;
					}


					this.updateFunds({ current_order: result.data.purchaseCoinbaseOrderRequest });

					this.openCoinbaseWindow();


					this.transaction_id = result.data.purchaseCoinbaseOrderRequest.id;
					this.order_id = result.data.purchaseCoinbaseOrderRequest.payload.order_id;

					UserService.sendAnalytics({
						event: 'begin_checkout',
						data: {
							currency: this.funds.currency,
							transaction_id: this.transaction_id,
							value: 0,
							provider: 'coinbase',

						}
					});
					this.purchase_loading = false;
				}
				this.purchase_loading = false;
				this.showLoader = false;
			} catch (err: any) {
				this.showLoader = false;
				this.purchase_loading = false;
				this.$router.push('/funds/purchase/coinbase-error').catch(() => { });
				TransactionService.purchasePaypalOrderCaptureError({
					data: {
						provider: 'coinbase',
						total_amount_usd: '',
						total_amount_mph: '',
						country: this.user?.document_country,
						error_details: 'Coinbase Purchase Order Error - ' + err.toString(),
						eth_address: this.user?.activePortfolio?.eth_address
					}
				});
				this.logSentryError('Coinbase Purchase Order Error - ' + err.toString());
				if (err) return this.error(err);

			}
		}
	}
});
</script>
<style scoped src="../../assets/css/payment.css"></style>
<style>
.donate-with-crypto {
	display: none;
}
</style>
<style scoped>
#coinbase-button-container {
	min-width: 4px;
	color: #fff;
	background-color: #fff !important;
	margin-bottom: -1rem;
	display: none;
	overflow: hidden;
	align-items: center;
	justify-content: center;
	position: absolute;
}

.spinner {
	width: 200px;
}

#coinbase-button-container .spinner {
	top: 10px;
	display: none !important;
}

@media only screen and (max-width: 768px) {
	#coinbase-button-container {
		min-width: 100%;
	}
}

.coinbase_frame {
	width: 100%;
	min-height: 500px;
}

.is-64 {
	width: 64px;
}
.is-full-width {
	width: 100%;
}
.mt-10 {
	margin-top: 10px;
}
.centered-flex-gap {
	display: flex;
	align-items: center;
	gap: 5px;
}
</style>
